import { gql } from '@apollo/client'
import { Address } from 'globals/models/User'

export const LOGIN = gql`
  mutation userSignIn(
    $email: String!,
    $password: String!,
    $rememberMe: Boolean
  ) {
    userSignIn(
      email: $email,
      password: $password,
      remember: $rememberMe
    ) {
      user {
        id,
        email,
        addresses {
          id,
          fullAddress,
          shortname
        }
      },
      token
    }
  }
`

export interface LoginVariables {
  email: string,
  password: string,
  rememberMe?: boolean
}

export interface LoginResult {
  userSignIn: {
    user: {
      id: number,
      email: string,
      mfaSms: boolean,
      addresses: Address[]
    },
    token: string
  }
}
